function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class SizeSelector extends HTMLElement {
  connectedCallback() {
    this.setupListeners();
  }
  setupListeners() {
    const encodedData = this.dataset.productData;
    const rawData = atob(encodedData);
    const data = JSON.parse(rawData);

    this.addEventListener("click", (e) => {
      const btn = e.target.closest("p.variant__size");
      const val = btn.dataset.value;
      const buttons = this.querySelectorAll("p.variant__size");
      buttons.forEach((button) => {
        button.classList.remove("active");
      });
      btn.classList.add("active");
      const matchingProducts = data.filter(
        (product) => product.option1 === val
      );
      this.currentVariant = matchingProducts[0];
      this.updateURL();
      this.updateVariantInput();
      this.updatePrice();
    });
  }
  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }
  updateVariantInput() {
    const productInput = document.querySelector(".product__id-input");
    productInput.value = this.currentVariant.id;
  }
  updatePrice() {
    const price = this.currentVariant.price;
    const span = document.querySelector(".isPRC");
    const formatter = new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency: "ARS",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    // Format the price
    let formattedPrice =
      this.currentVariant.price % 100 === 0
        ? formatter.format(this.currentVariant.price / 100).slice(0, -3)
        : formatter.format(this.currentVariant.price / 100);
    // Remove space between currency symbol and numbers
    formattedPrice = formattedPrice.replace(/\s/g, "");

    // Update the DOM elements with the extracted and formatted data
    span.innerHTML = formattedPrice;
  }
}

customElements.define("size-selector", SizeSelector);
